import React, {
  useContext,
  useEffect,
  useState
}                             from 'react';
import { useTranslation }     from 'react-i18next';
import { toast }              from 'react-toastify';
import Refresh                from '@material-ui/icons/Refresh';

import { historyPropType }    from '~/config/routerPropTypes';
import {
  createSubscription,
  editSubscription,
  subscription }              from '~/config/routes';

import SubscriptionRecord     from '~/records/SubscriptionRecord';
import Context                from './context';
import Request                from '~/providers/Request';

import ModalDelete            from '~/components/ModalDelete';
import PaperButtons           from '~/components/PaperButtons';
import GridContainer          from '~/components/GridContainer';
import GridItem               from '~/components/GridItem';
import InputShow              from '~/components/InputShow';
import Paper                  from '~/components/Paper';
import { AbilityContext }     from '~/contexts/Can';

const attrName = (attr) => SubscriptionRecord.hummanAttributeName(attr);

function ShowSubscription({history}) {
  const { t } = useTranslation();
  const { id } = history.location.route.getParams();
  const [ record, setRecord] = useState(new SubscriptionRecord());
  const { records, addRecords } = useContext(Context);
  const [loading, setLoading] = useState(true);
  const [openDropDown, setOpenDropDown] = useState(null);
  const [modal, setModal] = useState(false);
  const ability = useContext(AbilityContext);

  useEffect(() => {
    if(records && records[id]){
      setRecord( record.updateAttributes(records[id]) );
    }
    setLoading(true);
    Request.get(`/admin/plans/${id}`, {})
      .then( response => {
        setLoading(false);
        addRecords({ data: [response.data] }); //Array para reusar o util de transformar e jogar no contexto.
        setRecord( record.updateAttributes(response.data) );
      })
      .catch( e => {
        console.error(e);
        setLoading(false);
      });
  }, []);

  async function handleDelete(){
    setLoading(true);
    Request.del(`/admin/plans/${id}`)
    .then(() => {
      toast.success(t('delete-toast-success'));
      history.push(subscription.spec);
    })
    .catch(() => {
      setLoading(false);
      toast.error(t('delete-toast-fail'));
    });
    setModal(false);
  }

  return (
    <>
      <Paper
        Icon={Refresh}
        iconColor="blue"
        title={t('subscription.defSingular')}
        loading={loading}
        actions={<PaperButtons
          id={id}
          openDropDown={openDropDown}
          setOpenDropDown={setOpenDropDown}
          setModal={ability.can('delete', 'Subscriptions') ? setModal : null}
          backRoute={subscription}
          newRoute={ability.can('new', 'Subscriptions') ? createSubscription : null}
          editRoute={ability.can('edit', 'Subscriptions') ? editSubscription : null}
        />}
      >
        <GridContainer>
          <GridItem xs={12} md={8}>
            <InputShow
              label={attrName('name')}
              value={record.get('name')}
            />
          </GridItem>
            <GridItem xs={8} sm={10} md={3}>
              <InputShow
                label={attrName('lang')}
                value={record.get('lang')}
              />
            </GridItem>
            <GridItem xs={4} sm={2} md={1}>
              <InputShow
                label={attrName('is_active')}
                value={record.get('is_active')}
                type='boolean'
              />
            </GridItem>
            <GridItem xs={12} md={6}>
              <InputShow
                label={attrName('coin')}
                value={record.get('coin')}
              />
            </GridItem>
            <GridItem xs={12} md={6}>
              <InputShow
                label={attrName('month_price')}
                value={record.get('month_price')}
                type='float'
              />
            </GridItem>
            <GridItem xs={12} md={6}>
              <InputShow
                label={attrName('google_month_product_id')}
                value={record.get('google_month_product_id')}
              />
            </GridItem>
            <GridItem xs={12} md={6}>
              <InputShow
                label={attrName('apple_month_product_id')}
                value={record.get('apple_month_product_id')}
              />
            </GridItem>
          </GridContainer>
      </Paper>
      <ModalDelete
        modal={modal}
        onClose={() => {
          setModal(false);
          setOpenDropDown(null);
        }}
        name={record.get('name')}
        id={id}
        deleteAction={handleDelete}
      />
    </>
  );
}

  ShowSubscription.propTypes={
    history: historyPropType,
  };

export default ShowSubscription;
